import React , { Component } from 'react';
import { Col } from 'reactstrap';
import VertCardLabel from './VertCardLabel';
import { getLocalStorageInfo } from '../../../../utils';
import { checkPermission } from '../../../../utils_v2';
import { imgStoragePath } from '../../../../constants';
import editIcon from '../../../../shared/assets/img/edit_icon.svg';
import { avationPlcInstance, hanwahaInstance, mtInstance } from '../../../../shared_elements/components';
import SyncIcon from '@material-ui/icons/Sync';
import { Tooltip,IconButton } from '@material-ui/core';
export default class LesseeCard extends Component{
  constructor(props){
    super(props);
  }
  render(){
    const { lesseeInfo } = this.props;
    return(
      <Col xs="12" md="6" >
        <div className="vertical-card card-block">
          <h5 className="para"> Lessee
            {
            lesseeInfo?.archived_asset == false?
            checkPermission('contracts','lease_details', 'U') ?
              <img onClick = {this.props.toggleEditSideBar} width="16" className="editIcon" src={editIcon} alt="img"/>:null:null
            }
            <Tooltip title="Sync" arrow>
              <IconButton className="syncIcon" color="primary" onClick={this.props.onSync}>
                <SyncIcon color="primary" style={{ fontSize: "23px" }} />
              </IconButton>
            </Tooltip>
          </h5>
          <ul className="list-unstyled">
            <VertCardLabel label="Name" value={lesseeInfo.lessee && lesseeInfo.lessee.name ? lesseeInfo.lessee.name : '-'} />
            <VertCardLabel label= {avationPlcInstance? "Country of Incorporation":"Jurisdiction"} value={lesseeInfo.lessee_jurisdiction ? lesseeInfo.lessee_jurisdiction : '-'} />
            <VertCardLabel label="Habitual Base" value={lesseeInfo.habitual_base ? lesseeInfo.habitual_base: '-' } />
            <VertCardLabel label="Contact Address" value={lesseeInfo.lessee_contact_address ? lesseeInfo.lessee_contact_address : '-'} />
            <VertCardLabel label={avationPlcInstance || mtInstance?"Contact (Email)":"Contact (Email and Phone)"} value={lesseeInfo.lessee_contact_details ? lesseeInfo.lessee_contact_details : '-'} />
            {avationPlcInstance || mtInstance? <VertCardLabel label="Contact (Phone)" value={lesseeInfo.lessee_contact_phone_number ? lesseeInfo.lessee_contact_phone_number : '-'} />:null}
            {avationPlcInstance?<VertCardLabel label="Contact (Fax)" value={lesseeInfo.lessee_contact_fax ? lesseeInfo.lessee_contact_fax : '-'} />:null}
            {avationPlcInstance?<VertCardLabel label="Attention To" value={lesseeInfo.lessee_atten_to ? lesseeInfo.lessee_atten_to : '-'} />:null}
            <VertCardLabel label="Contractual Notice Address" value={lesseeInfo.lessee_contractual_notice_address ? lesseeInfo.lessee_contractual_notice_address : '-'} />            
            {hanwahaInstance ?<VertCardLabel label="Country Code" value={ lesseeInfo?.country_code ? `${lesseeInfo?.country_code?.name  + " (" +lesseeInfo?.country_code?.alpha_code_two + ")"}` : '-'} />: null}
             {
               lesseeInfo.same_operator_lessee ?
               <li className="flex-centered operator-same">
                 <img width="16" src={imgStoragePath+"icon_tick.png"} alt="img"/>
                 <span>Operator is same as Lessee</span>
               </li>:null
             }
           </ul>
         </div>
      </Col>
     )
  }
}
